import { createWebHistory, RouterHistory } from 'vue-router'

export function createHistory(domainName: string): RouterHistory {
	const path = process.env.NODE_ENV === 'production' ? '' : domainName

	return createWebHistory(process.env.BASE_URL + path)
}
